import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SetupTourGuidePage } from './setup-tour-guide.page';

const routes: Routes = [
  {
    path: '',
    component: SetupTourGuidePage
  },
  {
    path: 'setup-tour-guide-form',
    loadChildren: () => import('./setup-tour-guide-form/setup-tour-guide-form.module').then( m => m.SetupTourGuideFormPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SetupTourGuidePageRoutingModule {}
